import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "ciftora_token";
export const SUPPORT_TOKEN_KEY = "ciftora_support_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

/** Destek modunda yazma isteklerinde onay/sebep alan kanca (SupportProvider kaydeder). */
let writeGuard = null;
export const registerWriteGuard = (fn) => {
  writeGuard = fn;
};

api.interceptors.request.use(async (cfg) => {
  const support = localStorage.getItem(SUPPORT_TOKEN_KEY);
  const isSupportEndpoint = (cfg.url || "").startsWith("/support/");
  if (support && !(cfg.url || "").startsWith("/admin/support")) {
    cfg.headers.Authorization = `Bearer ${support}`;
    const method = (cfg.method || "get").toLowerCase();
    if (!["get", "head", "options"].includes(method) && !isSupportEndpoint && writeGuard) {
      const approved = await writeGuard(cfg);
      if (!approved) {
        const err = new Error("Destek modunda işlem iptal edildi");
        err.response = { data: { detail: "İşlem iptal edildi" } };
        throw err;
      }
      if (typeof approved === "string") cfg.headers["X-Support-Reason"] = approved;
    }
    return cfg;
  }
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Bir hata oluştu, lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const mediaUrl = (u) => {
  if (!u) return null;
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
};

export const money = (v, currency = "TRY") =>
  v == null
    ? "Fiyat belirtilmemiş"
    : new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);

export const dateTR = (v) =>
  v ? new Date(v).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" }) : "-";

export const timeTR = (v) =>
  v ? new Date(v).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "-";

/** Statik/nadiren değişen uçlar için paylaşılan istek önbelleği (mükerrer çağrıları engeller). */
const _getCache = new Map();

export function cachedGet(path, ttlMs = 300000) {
  const hit = _getCache.get(path);
  if (hit && Date.now() - hit.time < ttlMs) return hit.promise;
  const promise = api.get(path).then((r) => r.data);
  promise.catch(() => _getCache.delete(path));
  _getCache.set(path, { time: Date.now(), promise });
  return promise;
}

export async function streamChat(body, { onStart, onDelta, onDone, onError }) {
  const res = await fetch(`${API}/ai/chat/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(localStorage.getItem(TOKEN_KEY)
        ? { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` }
        : {}),
    },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) {
    let detail = "Ciftora AI şu anda yanıt veremedi, lütfen tekrar deneyin.";
    try {
      detail = (await res.json())?.detail || detail;
    } catch {
      /* yanıt JSON değil */
    }
    onError?.(detail);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const frames = buffer.split("\n\n");
    buffer = frames.pop() || "";
    for (const frame of frames) {
      const nameLine = frame.split("\n").find((l) => l.startsWith("event: "));
      const dataLine = frame.split("\n").find((l) => l.startsWith("data: "));
      if (!nameLine || !dataLine) continue;
      const name = nameLine.slice(7).trim();
      const data = JSON.parse(dataLine.slice(6));
      if (name === "start") onStart?.(data);
      else if (name === "delta") onDelta?.(data.content);
      else if (name === "done") onDone?.(data);
      else if (name === "error") onError?.(data.detail);
    }
  }
}

export async function downloadPdf(path, params) {
  const r = await api.get(path, { params, responseType: "blob" });
  const disp = r.headers["content-disposition"] || "";
  const match = /filename="?([^";]+)"?/.exec(disp);
  const url = URL.createObjectURL(r.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = match ? match[1] : "ciftora.com-belge.pdf";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
